export default __webpack_public_path__ + "static/media/1609.6818cb89.png";